<template>
  <div class="news-content-detail ly-card">
    <h2>{{ data.content_title }}</h2>
    <img :src="`${baseUrl}/${data.content_url}`" class="img" />
    <div class="content" v-html="data.content"></div>
  </div>
</template>
<script>
import localCache from '@/utils/localCache';

export default {
  name: 'newsContentDetail',
  data() {
    return {
      data: {},
      baseUrl: ''
    };
  },
  async mounted() {
    this.init();
    this.baseUrl = await this.$store.dispatch('app/getOssUrl');
  },
  methods: {
    init() {
      this.data = localCache.getItem('newsContentDetail');
    }
  },
  activated() {
    this.init();
  }
};
</script>

<style lang="less">
.news-content-detail {
  text-align: center;
  .img {
    max-width: 80%;
  }
  .content {
    text-align: left;
  }
}
</style>
